export default function getUserIdInfoReducer(state = { useridInfoState: [] }, action) {
    switch (action.type) {
        case 'USERID_INFO':
            return {
                useridInfoState: action.useridInfoState
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/getuseridinfo.jsx